import { render } from "./AddRosterPariwisataForm.vue?vue&type=template&id=6abddce1&ts=true"
import script from "./AddRosterPariwisataForm.vue?vue&type=script&lang=ts"
export * from "./AddRosterPariwisataForm.vue?vue&type=script&lang=ts"

import "./AddRosterPariwisataForm.vue?vue&type=style&index=0&id=6abddce1&lang=scss"

import exportComponent from "/builds/harapan-jaya/hjp/hjp-cms/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__